import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL } from '~/helpers/variables';

const instance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL + '/api/v1',
  // withCredentials: true,
});

export default instance;
